module.exports = __webpack_public_path__ + "static/media/dolomiten.66af539e.png";